// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"348dc1d0","300":"312615c9","315":"dbc74722","372":"87a8929b","374":"ae9bf6b7","816":"2af5f50a","858":"44e14631","974":"16f757b0"}[chunkId] + ".chunk.js";
};